"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachPebble = function SvgBeachPebble(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.874 2.21c1.636.32 3.739 1.472 3.739 2.423h.009c0 .799-.482 1.155-1.163 1.274 1.667.378 3.057 1.032 3.01 1.961h.008c-.044.857-1.428 1.602-3.068 2.074 2.672-.093 4.558.626 4.723 2.46.293 3.272-1.57 3.994-3.99 4.103 3.664.48 6.614 1.782 7.93 3.457.584.74.191 2.038-.604 2.038H1.572C.777 22 .393 20.702.97 19.962c1.505-1.924 5.147-3.346 9.55-3.612-2.772-.26-5.393-.888-5.601-2.266-.235-1.508.42-2.722 5.257-3.608-2.386-.055-3.658-.622-3.584-2.15.139-2.911 1.921-2.985 3.98-2.86-1.326-.28-2.297-.608-2.107-1.583.447-2.252 1.767-1.994 3.398-1.675l.012.002Z",
    fill: "#000"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgBeachPebble);
var _default = exports["default"] = Memo;